import {
  LOGOUT,
  START_REDIRECT,
  SET_NAVBAR,
  TOGGLE_ACTION_SHEET,
  SET_PLATFORM_TYPE,
  SET_TRACKING_EVENT,
  SET_DARK_MODE
} from "app/DealMachineCore/types";

import GoogleAPI from "app/DealMachineCore/apis/GoogleMapsAPI";
const ip_api = GoogleAPI.ipAPI();

export const AppConfig = () => {
  return {
    api_url: process.env.REACT_APP_API_URL,
    app_version: 10,
    user_version: 5,
    hubspot_id: "3944252",
    google_analytics: "UA-83632441-1",
    facebook_pixel: "107943933079807",
    contentful_space: "tbaxdqcpgx77",
    contentful_token:
      "f2f178e08a5546d8d6c3784466d236786181d83d601ea2b6dd8bbafb3b1a4782",
    device: "desktop",
    platform: "desktop", //maybe get browser here eventually
    google_api: "AIzaSyBKxAXFBe8TSxxLFX6jDKxZdTu8-rdv_6s",
    google_static_map_api: "AIzaSyCO9U4NJMj_oUhy-ELQZtf1GRUFNKME6EQ",
    google_static_map_signature: "VxNWMORqMwGcvX6GR5B1aC2-Zb8=",
    stripe_live: "pk_live_JBvxbr2qdLSZCQjKd3hRWhuE"
    //stripe_live: "pk_test_L3fT1A2LRpXXFHouee7y0S89"
  };
};

export const iconTurnMap = () => {
  return false;
};

export const checkApiVersion = () => {
  //no action needed. the web should always be up to date
};

export const getStripeToken = async card_token => {
  return {
    last4: card_token.card.last4,
    tokenId: card_token.id
  };
};

export const saveData = async ({ prop, value }) => {
  try {
    window.localStorage.setItem(prop, value);
  } catch (error) {}
};

export const removeData = async dispatch => {
  window.localStorage.removeItem("token");
  window.localStorage.removeItem("user");
  if (dispatch) {
    dispatch({ type: LOGOUT });
    dispatch({ type: START_REDIRECT, payload: "/login" });
  }
};

export const checkUserLocationPermission = (
  success = () => {},
  error = () => {}
) => {
  success();
};

export const displayIntercom = () => {};

export const openMobileSettings = () => {};

export const dismissMobileKeyboard = () => {
  //mobile only function...just leave blank
};

export const openUrl = url => {
  window.open(url, "_blank");
};

export const openEmail = ({ email, subject }) => {
  //mobile only function...just leave blank
};
export const callPhoneNumber = number => {
  //mobile only function...just leave blank
};
export const textPhoneNumber = number => {
  //mobile only function...just leave blank
};
export const checkGalleryPermissions = () => {
  //mobile only function...just leave blank
};
export const checkCameraPermissions = () => {
  //mobile only function...just leave blank
};

export const checkLocationPermission = () => {
  //mobile only function...just leave blank
};

/*REDUX ACTIONS */

export const setNavbar = ({ navbar }) => {
  return {
    type: SET_NAVBAR,
    payload: { navbar }
  };
};

export const logout = () => {
  return dispatch => {
    removeData(dispatch);
  };
};

export const toggleActionSheet = (type, data = null) => {
  return {
    type: TOGGLE_ACTION_SHEET,
    payload: { type, data }
  };
};

export const setPlatformType = type => {
  return {
    type: SET_PLATFORM_TYPE,
    payload: type
  };
};

export const setTrackingEvent = event => {
  return {
    type: SET_TRACKING_EVENT,
    payload: event
  };
};

export const combinePropertyArrays = (
  originalArray,
  newArray,
  array_length = 300
) => {
  var newCombinedArray = [];

  for (var i = 0; i < originalArray.length; i++) {
    var addItem = originalArray[i];
    var found = false;
    for (var j = 0; j < newArray.length; j++) {
      if (newArray[j].property_id == addItem.property_id) {
        found = true;
        addItem = {
          ...newArray[j],
          highlighted: addItem.highlighted
        };
      }
    }

    newCombinedArray.push(addItem);
  }

  for (var k = 0; k < newArray.length; k++) {
    var addNewItem = newArray[k];
    var found_new_item = false;

    for (var l = 0; l < newCombinedArray.length; l++) {
      if (newCombinedArray[l].property_id == addNewItem.property_id) {
        found_new_item = true;
      }
    }
    if (found_new_item != true) {
      newCombinedArray.push(addNewItem);
    }
  }

  if (newCombinedArray.length >= array_length && array_length != 0) {
    return newArray;
  } else {
    return newCombinedArray;
  }
};

export const combineArrays = (originalArray, newArray, array_length = 300) => {
  var newCombinedArray = [];

  for (var i = 0; i < originalArray.length; i++) {
    var addItem = originalArray[i];
    var found = false;
    for (var j = 0; j < newArray.length; j++) {
      if (parseInt(newArray[j].id) === parseInt(addItem.id)) {
        found = true;
        addItem = newArray[j];
      }
    }

    newCombinedArray.push(addItem);
  }

  for (var k = 0; k < newArray.length; k++) {
    var addNewItem = newArray[k];
    var found_new_item = false;

    for (var l = 0; l < newCombinedArray.length; l++) {
      if (newCombinedArray[l].id == addNewItem.id) {
        found_new_item = true;
      }
    }
    if (found_new_item != true) {
      newCombinedArray.push(addNewItem);
    }
  }

  if (newCombinedArray.length >= array_length) {
    return newArray;
  } else {
    return newCombinedArray;
  }
};

export const getMyLocation = ({ success = () => {}, onError = () => {} }) => {
  if ("geolocation" in navigator) {
    // check if geolocation is supported/enabled on current browser
    navigator.geolocation.getCurrentPosition(
      position => {
        // for when getting location is a success
        success({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        });
      },
      error_message => {
        // for when getting location results in an error
        onError();
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 1000 }
    );
  } else {
    onError();
  }
  /*
   }else{


      ip_api.ipLocation()
      .then(response => {
        if(response.problem != null){

        }else if(response.status){
          if(response.status != 200){
          }else{
            success({
              latitude: response.data.latitude,
              longitude: response.data.longitude
            });
          }
        }
      })

  }
  */
};

export const getCurrentLocation = (props, success = () => {}) => {
  if ("geolocation" in navigator) {
    // check if geolocation is supported/enabled on current browser
    navigator.geolocation.getCurrentPosition(
      position => {
        // for when getting location is a success

        props.setLocation({
          lat: position.coords.latitude,
          long: position.coords.longitude
        });
        //props.reverseGeocode({location: position.coords.latitude+","+position.coords.longitude });
        props.toggleRegionChange(true);

        success(position.coords);
      },
      error_message => {
        // for when getting location results in an error

        ip_api.ipLocation().then(response => {
          if (response.problem != null) {
          } else if (response.status) {
            if (response.status != 200) {
            } else {
              props.setLocation({
                lat: response.data.latitude,
                long: response.data.longitude
              });
              //props.reverseGeocode({location: response.data.latitude+","+response.data.longitude });
              props.toggleRegionChange(true);

              success(response.data);
            }
          }
        });
      }
    );
  } else {
    ip_api.ipLocation().then(response => {
      if (response.problem != null) {
      } else if (response.status) {
        if (response.status != 200) {
        } else {
          props.setLocation({
            lat: response.data.latitude,
            long: response.data.longitude
          });
          //props.reverseGeocode({location: response.data.latitude+","+response.data.longitude });
          props.toggleRegionChange(true);

          success(response.data);
        }
      }
    });
  }
};

export const openMap = ({ latitude, longitude }) => {};

export const setDarkMode = toggle => {
  let dark_mode = toggle;
  if (!dark_mode) {
    dark_mode = "dark_mode_off";
  }

  saveData({ prop: "dark_mode", value: toggle });

  return {
    type: SET_DARK_MODE,
    payload: toggle
  };
};

export const requestExternalWritePerms = async () => {
  return false;
};
